import React, { useState } from "react";
import ChatContainer from "../../../components/JobSeekerOnboarding/ChatContainer";

export default function JobSeekerCompleteProfile() {
  const [isCompleted, setIsCompleted] = useState(false);
  const [profileData, setProfileData] = useState(null);

  const handleOnboardingComplete = (responses) => {
    console.log("Onboarding completed with responses:", responses);
    setProfileData(responses);
    setIsCompleted(true);

    // Here you would typically send the data to your backend
    // For now, we'll just store it in state
    // Example API call:
    // saveJobSeekerProfile(responses);
  };

  if (isCompleted) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Profile Complete!
          </h2>
          <p className="text-gray-600 mb-6">
            Thank you for completing your profile. We'll use this information to
            match you with the best job opportunities.
          </p>
          <button
            onClick={() => {
              // Navigate to dashboard or next step
              console.log("Navigate to dashboard");
            }}
            className="w-full bg-[#059669] text-white py-3 px-4 rounded-lg hover:bg-[#047857] transition-colors duration-200"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto h-screen">
        <ChatContainer onComplete={handleOnboardingComplete} />
      </div>
    </div>
  );
}
